import React from 'react';
import './App.css';
import 'antd/dist/antd.css';
import ColorCardsPage from './pages/color-cards-page';

function App() {
    return (
        <ColorCardsPage />
    );
}

export default App;
